// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labelWrapper--3DsMTMfX {\n  display: inline-grid;\n  grid-auto-flow: column;\n  grid-gap: 6px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelWrapper": "labelWrapper--3DsMTMfX"
};
export default ___CSS_LOADER_EXPORT___;
